module.exports = __webpack_public_path__ + "img/01-d8e78a.png";